export default "__VITE_ASSET__NP5OWBJq__"